import { useTranslation } from "react-i18next";

const CategoryTabs = ({ categories, activeCategory, onSelect }) => {
    const { i18n } = useTranslation();
    const isEnglish = (i18n.language || i18n.resolvedLanguage || "").toLowerCase().startsWith("en");

    const getCategoryName = (category) => isEnglish ? category.nameEn : category.name;

    return (
        <div className="mt-6 flex flex-nowrap gap-3 overflow-x-auto pb-2 scrollbar-thin">
            {categories.map((category) => (
                <button
                    key={category.id}
                    type="button"
                    onClick={() => onSelect(category)}
                    className={`whitespace-nowrap rounded-full px-4 py-2 text-xs font-semibold transition ${
                        activeCategory?.id === category.id
                            ? "bg-primary text-white focus:outline-none"
                            : "bg-slate-100 text-slate-500 focus:outline-none"
                    }`}
                >
                    {getCategoryName(category)}
                </button>
            ))}
        </div>
    );
};

export default CategoryTabs;
